// 基础状态原子
import { atom } from 'jotai';
import { atomWithStorage, loadable } from 'jotai/utils';
import { Message, Conversation } from './types';

// 使用Storage保存正在处理的消息，确保跨Tab同步
export const pendingMessagesStorage = atomWithStorage<Record<string, {
  conversationId: string;
  messageText: string;
  timestamp: string;
  abortController?: AbortController;
}>>('pendingMessages', {});

// 基础状态 atoms
export const conversationsAtom = atomWithStorage<Conversation[]>('conversations', []);
export const selectedConversationIdAtom = atomWithStorage<string | null>('selectedConversationId', null);
export const messagesAtom = atom<Message[]>([]);
export const conversationsLoadingAtom = atom<boolean>(false);
export const conversationLoadingAtom = atom<boolean>(false);
export const isSendingAtom = atom<boolean>(false);
export const loadingMoreAtom = atom<boolean>(false);
export const hasMoreMessagesAtom = atom<boolean>(false);
export const oldestMessageIdAtom = atom<string | null>(null);

// 流式聊天开关
export const streamingChatEnabledAtom = atomWithStorage<boolean>('streamingChatEnabled', true);
export const loadableStreamingChatEnabledAtom = loadable(streamingChatEnabledAtom);

// 加载状态 atoms (使用 loadable)
export const loadableConversationsAtom = loadable(conversationsAtom);

// 派生 atoms
export const selectedConversationAtom = atom(
  (get) => {
    const selectedId = get(selectedConversationIdAtom);
    const conversations = get(conversationsAtom);

    if (!selectedId) return null;
    return conversations.find(c => c.id === selectedId) || null;
  }
);
